import type { SupportedLocale } from '@99designs/i18n';
import type { DesignProductSearchResult } from '../../../types/Search';

interface SearchTrackingParamProps {
    inputValue: string;
    selectedProduct: DesignProductSearchResult;
    position: number;
    resultLength: number;
    locale: SupportedLocale;
}

export const getProductSearchTrackingParams = ({
    inputValue,
    selectedProduct,
    position,
    resultLength,
    locale,
}: SearchTrackingParamProps) => ({
    category: 'Internal Search',
    label: inputValue,
    eventDetail: `Design Services:Hub Page;${selectedProduct.designProductPresenter.ctaUrl(
        locale
    )};${resultLength};${position};1;${position}`,
    searchTerm: inputValue,
    name: selectedProduct.designProductPresenter.translatedTitle(),
    core_product_id: '',
    core_product_version: '',
    position,
    list_section_id: 'Product',
    application: 'DesignServicesHubSearch',
    location: window.location.href,
    query: inputValue,
    resultId: selectedProduct.designProductPresenter.key,
    resultPosition: position,
    resultSource: 'Designable Products',
    resultDestination: selectedProduct.designProductPresenter.ctaUrl(locale),
    sectionPosition: position,
    sectionName: 'Product',
});

export const trackPopoverVisibility = (
    node: HTMLDivElement | null,
    onPopoverOpen: (isOpen: boolean) => void
) => {
    if (!node) return onPopoverOpen(false);

    const isVisible =
        !node.hasAttribute('aria-hidden') && getComputedStyle(node).display !== 'none';

    return onPopoverOpen(isVisible);
};
